import jQuery from 'jquery';
import config from 'src/config';

import appboyService from 'services/appboy';

function AppConfig($compileProvider, sdkConfigProvider, cacheConfigProvider, segmentProvider, AUTH_TYPES) {
  // Angular debugging
  // https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(config.NODE_ENV !== 'production');

  //change data tables behaviour from an alert to throwing errors
  jQuery.fn.dataTableExt.sErrMode = 'throw';

  appboyService.init();

  appboyService.stopWebTracking();

  sdkConfigProvider
    .setApiKey(config.TL_API_KEY)
    .setApiBaseUrl(config.SDK_API_URL)
    .setEnableDebugMode(config.NODE_ENV !== 'production')
    .setEnableSecureCookie(false)
    .setEnableCookieDomain(false)
    // .setEnableSecureCookie(window.ENV.ENV_PROD)
    // .setEnableCookieDomain(window.ENV.ENV_PROD)
    .setClient('nightpro')
    .setAuthType(AUTH_TYPES.MANAGEMENT)
    .setGetUserOnStartUp(false);

  cacheConfigProvider
    .cacheResourceEndpoints('jsSdk.permission.resource', [
      'list',
      'listByManagementUserId'
    ])
    .cacheResourceEndpoints('jsSdk.tag', [
      'list'
    ])
    .cacheResourceEndpoints('jsSdk.attributionSource', [
      'listByManagementUserId',
      'listByOrganizationId'
    ]);

  // Enable segment.io with our write key.
  if (config.SEGMENT_WRITE_KEY) {
    segmentProvider
      .setKey(config.SEGMENT_WRITE_KEY)
      .setDebug(config.SEGMENT_DEBUG);
  }

  window.Stripe.setPublishableKey(config.STRIPE_PUBLIC_KEY);
}

AppConfig.$inject = [
  '$compileProvider',
  'jsSdk.configProvider',
  'jsSdk.cacheConfigProvider',
  'segmentProvider',
  'jsSdk.AUTH_TYPES'
];

export default AppConfig;



// WEBPACK FOOTER //
// ./src/appConfig.js